import { gql } from 'Utils/apolloClient'

const onInstallmentPayment = gql`
  subscription onInstallmentPayment {
    installmentPayment {
      installment {
        id
        payment {
          failedReason
          id
          state
        }
      }
    }
  }
`

export default onInstallmentPayment
